/**
 * Answers the transit API for the sample transition (data.ts), so it renders
 * with the workspace's own components: services/transit.ts sends any path
 * naming a sample- ID here instead of to the server. Reads return the sample;
 * anything that would change it is refused with a 403 the page shows.
 */
import {
  SAMPLE_DOCUMENTS, SAMPLE_DOCUMENT_TEXT, SAMPLE_GRAPH, SAMPLE_INFO_REQUESTS, SAMPLE_READINESS, SAMPLE_TRANSITION,
  SAMPLE_TRANSITION_ID,
} from './data'

export const SAMPLE_READ_ONLY = "This is an example transition, so it can't be changed. Start your own to try this."

export const isSampleId = (id: string) => id.startsWith('sample-')
export const isSamplePath = (path: string) => /(^|\/)sample-/.test(path)

const reply = (body: unknown, status = 200) =>
  new Response(JSON.stringify(body), { status, headers: { 'Content-Type': 'application/json' } })

export function sampleResponse(path: string, init: RequestInit = {}): Response {
  if ((init.method ?? 'GET') !== 'GET') return reply({ error: SAMPLE_READ_ONLY }, 403)
  const t = `/transitions/${SAMPLE_TRANSITION_ID}`
  const text = /^\/documents\/([^/]+)\/text$/.exec(path)?.[1]
  switch (path) {
    case t: return reply(SAMPLE_TRANSITION)
    case `${t}/graph`: return reply(SAMPLE_GRAPH)
    case `${t}/info-requests`: return reply(SAMPLE_INFO_REQUESTS)
    case `${t}/documents`: return reply(SAMPLE_DOCUMENTS)
    case `${t}/readiness`: return reply(SAMPLE_READINESS)
    case `${t}/policies`:
    case `${t}/package`:
      return reply([])
  }
  if (text && SAMPLE_DOCUMENT_TEXT[text] !== undefined) return reply({ text: SAMPLE_DOCUMENT_TEXT[text] })
  return reply({ error: 'Not part of the sample' }, 404)
}
